module.exports = __webpack_public_path__ + "img/why-use-oc-image-01.fa33671.svg";